import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!(
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULES, app: APP_PATHS.DETECTIONS }) ||
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULES, app: APP_PATHS.DETECTIONS, permission: Permission.UPDATE })
    );
    context.validatePermissions({ isAllowed, preload });
  },
});
